import FacilitySettingsService from './facility-settings-service';

/***
 * A Service used to fetch, store, and organize FacilitySettings, which are currently used on both the
 * Client Edit page and the Stats Enter Data page.
 */
const facilitySettings = angular
    .module('FacilityData.Common.FacilitySettings', [])
    .service('FacilitySettings', FacilitySettingsService)
    .name;

export default facilitySettings;


// WEBPACK FOOTER //
// ./app/common/facility-settings/facility-settings.js